import { render } from "./HotDeals.vue?vue&type=template&id=0f5197dd&scoped=true"
import script from "./HotDeals.vue?vue&type=script&lang=js"
export * from "./HotDeals.vue?vue&type=script&lang=js"

import "./HotDeals.vue?vue&type=style&index=0&id=0f5197dd&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5197dd"]])

export default __exports__